import { onMounted as ue, onUnmounted as le, effectScope as de, readonly as u, computed as v, ref as a } from "vue";
function g() {
  var e;
  if (!("Telegram" in window))
    throw new Error("Telegram SDK not found. Make sure https://telegram.org/js/telegram-web-app.js script is installed.");
  return (e = window == null ? void 0 : window.Telegram) == null ? void 0 : e.WebApp;
}
const l = (e, t, n = { manual: !1 }) => {
  const { manual: o } = n, s = g(), r = () => s.onEvent(e, t), i = () => s.offEvent(e, t);
  return o ? r() : (ue(r), le(i)), {
    off: i
  };
};
function H(e, t) {
  return l("activated", e, t);
}
function j(e, t) {
  return l("deactivated", e, t);
}
function $(e, t) {
  return l("themeChanged", e, t);
}
function U(e, t) {
  return l("viewportChanged", e, t);
}
function pe(e, t) {
  return l("safeAreaChanged", e, t);
}
function fe(e, t) {
  return l("contentSafeAreaChanged", e, t);
}
function Ae(e, t) {
  return l("mainButtonClicked", e, t);
}
function ve(e, t) {
  return l("secondaryButtonClicked", e, t);
}
function Se(e, t) {
  return l("backButtonClicked", e, t);
}
function me(e, t) {
  return l("settingsButtonClicked", e, t);
}
function ge(e, t) {
  return l("invoiceClosed", e, t);
}
function he(e, t) {
  return l("popupClosed", e, t);
}
function be(e, t) {
  return l("qrTextReceived", e, t);
}
function we(e, t) {
  return l("scanQrPopupClosed", e, t);
}
function Ce(e, t) {
  return l("clipboardTextReceived", e, t);
}
function Be(e, t) {
  return l("writeAccessRequested", e, t);
}
function ye(e, t) {
  return l("contactRequested", e, t);
}
function W(e, t) {
  return l("biometricManagerUpdated", e, t);
}
function z(e, t) {
  return l("biometricAuthRequested", e, t);
}
function Q(e, t) {
  return l("biometricTokenUpdated", e, t);
}
function Me(e, t) {
  return l("fullscreenChanged", e, t);
}
function Ve(e, t) {
  return l("fullscreenFailed", e, t);
}
function Le(e, t) {
  return l("homeScreenAdded", e, t);
}
function ke(e, t) {
  return l("homeScreenChecked", e, t);
}
function Re(e, t) {
  return l("accelerometerStarted", e, t);
}
function xe(e, t) {
  return l("accelerometerStopped", e, t);
}
function _(e, t) {
  return l("accelerometerChanged", e, t);
}
function K(e, t) {
  return l("accelerometerFailed", e, t);
}
function Ee(e, t) {
  return l("deviceOrientationStarted", e, t);
}
function Ie(e, t) {
  return l("deviceOrientationStopped", e, t);
}
function N(e, t) {
  return l("deviceOrientationChanged", e, t);
}
function J(e, t) {
  return l("deviceOrientationFailed", e, t);
}
function Fe(e, t) {
  return l("gyroscopeStarted", e, t);
}
function qe(e, t) {
  return l("gyroscopeStopped", e, t);
}
function X(e, t) {
  return l("gyroscopeChanged", e, t);
}
function Y(e, t) {
  return l("gyroscopeFailed", e, t);
}
function Z(e, t) {
  return l("locationManagerUpdated", e, t);
}
function ee(e, t) {
  return l("locationRequested", e, t);
}
function Pe(e, t) {
  return l("shareMessageSent", e, t);
}
function Oe(e, t) {
  return l("shareMessageFailed", e, t);
}
function Te(e, t) {
  return l("emojiStatusSet", e, t);
}
function De(e, t) {
  return l("emojiStatusFailed", e, t);
}
function Ge(e, t) {
  return l("emojiStatusAccessRequested", e, t);
}
function He(e, t) {
  return l("fileDownloadRequested", e, t);
}
function d(e, t) {
  return (...n) => {
    const { hooks: o, omitReturn: s } = t || {};
    o != null && o.before && o.before(n);
    const r = e(...n);
    if (o != null && o.after && o.after(n, r), !s)
      return r;
  };
}
function b(e) {
  return (...t) => new Promise((n) => e(...t, n));
}
function R(e) {
  return (...t) => new Promise((n) => e(...t, n));
}
function V(e) {
  return (...t) => new Promise(
    (n, o) => e(...t, (s, r) => s ? o(s) : n(r))
  );
}
function je(e, t) {
  return (...n) => new Promise(
    (o) => e(...n, (...s) => o(t(...s)))
  );
}
function w(e) {
  let t = !1, n;
  return function() {
    return t || (de(!0).run(() => {
      n = e();
    }), t = !0), n;
  };
}
function te(e, t) {
  const n = (e || "").trim().split(".").map(Number), o = (t || "").trim().split(".").map(Number), s = Math.max(n.length, o.length);
  for (let r = 0; r < s; r++) {
    const i = n[r] || 0, c = o[r] || 0;
    if (i !== c)
      return i > c ? 1 : -1;
  }
  return 0;
}
function A(e, t) {
  return te(e, t) >= 0;
}
function C(e, t) {
  return te(e, t) >= 0 ? e : t;
}
const ne = w(() => ({
  webApp: g()
}));
function $e() {
  const {
    webApp: e
  } = ne(), t = b(e.showConfirm);
  function n(c, f) {
    if (f)
      e.showConfirm(c, f);
    else
      return t(c);
  }
  const o = R(e.showAlert);
  function s(c, f) {
    if (f)
      e.showAlert(c, f);
    else
      return o(c);
  }
  const r = b(e.showPopup);
  function i(c, f) {
    if (f)
      e.showPopup(c, f);
    else
      return r(c);
  }
  return {
    showConfirm: n,
    showAlert: s,
    showPopup: i,
    onClose: he
  };
}
function Ue(e) {
  const { webApp: t } = ne(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "6.2") && $e()
  };
}
const x = w(() => {
  const e = g(), t = a(e.BackButton.isVisible);
  return {
    webApp: e,
    isVisible: t,
    updateState: () => {
      t.value = e.BackButton.isVisible;
    }
  };
});
function We() {
  const {
    isVisible: e
  } = x();
  return {
    isVisible: u(e)
  };
}
function ze() {
  const {
    webApp: e,
    isVisible: t,
    updateState: n
  } = x(), o = d(e.BackButton.show, {
    hooks: {
      after: n
    },
    omitReturn: !0
  }), s = d(e.BackButton.hide, {
    hooks: {
      after: n
    },
    omitReturn: !0
  });
  return {
    isVisible: v({
      get() {
        return t.value;
      },
      set(r) {
        r ? o() : s();
      }
    }),
    show: o,
    hide: s,
    onClick: Se
  };
}
function Qe(e) {
  const { webApp: t } = x(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...We(),
    ...A(n, "6.1") && ze()
  };
}
const E = w(() => {
  const e = g(), t = a(e.BiometricManager.isInited), n = a(e.BiometricManager.isBiometricAvailable), o = a(e.BiometricManager.biometricType), s = a(e.BiometricManager.isAccessRequested), r = a(e.BiometricManager.isAccessGranted), i = a(e.BiometricManager.isBiometricTokenSaved), c = a(e.BiometricManager.deviceId);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.BiometricManager.isInited, n.value = e.BiometricManager.isBiometricAvailable, o.value = e.BiometricManager.biometricType, s.value = e.BiometricManager.isAccessRequested, r.value = e.BiometricManager.isAccessGranted, i.value = e.BiometricManager.isBiometricTokenSaved, c.value = e.BiometricManager.deviceId;
    },
    isInited: t,
    isBiometricAvailable: n,
    biometricType: o,
    isAccessRequested: s,
    isAccessGranted: r,
    isBiometricTokenSaved: i,
    deviceId: c
  };
});
function _e() {
  const {
    isInited: e,
    isBiometricAvailable: t,
    biometricType: n,
    isAccessRequested: o,
    isAccessGranted: s,
    isBiometricTokenSaved: r,
    deviceId: i
  } = E();
  return {
    isInited: u(e),
    isBiometricAvailable: u(t),
    biometricType: u(n),
    isAccessRequested: u(o),
    isAccessGranted: u(s),
    isBiometricTokenSaved: u(r),
    deviceId: u(i)
  };
}
function Ke() {
  const {
    webApp: e,
    updateState: t
  } = E(), n = R(e.BiometricManager.init);
  function o(h) {
    if (h)
      e.BiometricManager.init(h);
    else
      return n();
  }
  const s = b(e.BiometricManager.requestAccess);
  function r(h, S) {
    if (S)
      e.BiometricManager.requestAccess(h, S);
    else
      return s(h);
  }
  const i = je(
    e.BiometricManager.authenticate,
    (h, S) => ({ isAuthenticated: h, token: S })
  );
  function c(h, S) {
    if (S)
      e.BiometricManager.authenticate(h, S);
    else
      return i(h);
  }
  const f = b(e.BiometricManager.updateBiometricToken);
  function B(h, S) {
    if (S)
      e.BiometricManager.updateBiometricToken(h, S);
    else
      return f(h);
  }
  return W(t), z(t), Q(t), {
    init: o,
    requestAccess: r,
    authenticate: c,
    updateToken: B,
    openSettings: d(e.BiometricManager.openSettings, {
      omitReturn: !0
    }),
    onManagerUpdate: W,
    onAuthRequest: z,
    onTokenUpdate: Q
  };
}
function Ne(e) {
  const { webApp: t } = E(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ..._e(),
    ...A(n, "7.2") && Ke()
  };
}
const M = w(() => {
  const e = g(), t = a(!1), n = a(e.isClosingConfirmationEnabled), o = a(e.isActive);
  return {
    webApp: e,
    updateState: () => {
      o.value = e.isActive, n.value = e.isClosingConfirmationEnabled;
    },
    isReady: t,
    isActive: o,
    isClosingConfirmationEnabled: n
  };
});
function Je() {
  const {
    webApp: e,
    isReady: t,
    isActive: n,
    isClosingConfirmationEnabled: o
  } = M();
  return {
    initData: e.initData,
    initDataUnsafe: e.initDataUnsafe,
    platform: e.platform,
    sendData: e.sendData,
    openLink: e.openLink,
    openTelegramLink: e.openTelegramLink,
    ready: d(e.ready, {
      hooks: {
        after: () => {
          t.value = !0;
        }
      }
    }),
    close: e.close,
    isClosingConfirmationEnabled: u(o),
    isActive: u(n),
    isReady: u(t),
    isPlatform: st
  };
}
function Xe() {
  const { webApp: e } = M(), t = b(e.openInvoice);
  function n(o, s) {
    if (s)
      e.openInvoice(o, s);
    else
      return t(o);
  }
  return {
    openInvoice: n,
    onInvoiceClose: ge
  };
}
function Ye() {
  const {
    webApp: e,
    updateState: t,
    isClosingConfirmationEnabled: n
  } = M(), o = d(e.enableClosingConfirmation, {
    hooks: {
      after: t
    }
  }), s = d(e.disableClosingConfirmation, {
    hooks: {
      after: t
    }
  });
  return {
    isClosingConfirmationEnabled: v({
      get() {
        return n.value;
      },
      set(r) {
        r ? o() : s();
      }
    })
  };
}
function Ze() {
  const { webApp: e } = M();
  return {
    switchInlineQuery: e.switchInlineQuery
  };
}
function et() {
  const { webApp: e } = M(), t = b(e.requestContact);
  function n(r) {
    if (r)
      e.requestContact(r);
    else
      return t();
  }
  const o = b(e.requestWriteAccess);
  function s(r) {
    if (r)
      e.requestWriteAccess(r);
    else
      return o();
  }
  return {
    requestContact: n,
    requestWriteAccess: s,
    onContactRequest: ye,
    onWriteAccessRequest: Be
  };
}
function tt() {
  const { webApp: e } = M();
  return {
    shareToStory: e.shareToStory
  };
}
function nt() {
  const {
    webApp: e,
    updateState: t
  } = M(), n = b(e.shareMessage);
  function o(i, c) {
    if (c)
      e.shareMessage(i, c);
    else
      return n(i);
  }
  const s = b(e.downloadFile);
  function r(i, c) {
    if (c)
      e.downloadFile(i, c);
    else
      return s(i);
  }
  return H(t), j(t), {
    shareMessage: o,
    downloadFile: r,
    onActive: H,
    onDeactive: j,
    onShareMessageSent: Pe,
    onShareMessageFail: Oe,
    onFileDownloadRequest: He
  };
}
function ot(e) {
  const { webApp: t } = M(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...Je(),
    ...A(n, "6.1") && Xe(),
    ...A(n, "6.2") && Ye(),
    ...A(n, "6.7") && Ze(),
    ...A(n, "6.9") && et(),
    ...A(n, "7.8") && tt(),
    ...A(n, "8.0") && nt()
  };
}
function Kt(e) {
  return A(e, g().version);
}
function st(e) {
  return g().platform === e;
}
const L = w(() => {
  const e = g(), t = a(e.isExpanded), n = a(e.viewportHeight), o = a(e.viewportStableHeight), s = a(e.isFullscreen), r = a(e.isOrientationLocked), i = a(e.isVerticalSwipesEnabled), c = a(e.safeAreaInset), f = a(e.contentSafeAreaInset);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.isExpanded, n.value = e.viewportHeight, o.value = e.viewportStableHeight, s.value = e.isFullscreen, r.value = e.isOrientationLocked, i.value = e.isVerticalSwipesEnabled, c.value = {
        ...e.safeAreaInset
      }, f.value = {
        ...e.contentSafeAreaInset
      };
    },
    isExpanded: t,
    viewportHeight: n,
    viewportStableHeight: o,
    isFullscreen: s,
    isOrientationLocked: r,
    isVerticalSwipesEnabled: i,
    safeAreaInset: c,
    contentSafeAreaInset: f
  };
});
function rt() {
  const {
    webApp: e,
    updateState: t,
    isExpanded: n,
    viewportHeight: o,
    viewportStableHeight: s,
    isFullscreen: r,
    isOrientationLocked: i,
    isVerticalSwipesEnabled: c,
    safeAreaInset: f,
    contentSafeAreaInset: B
  } = L();
  return U(t), {
    expand: d(e.expand, {
      hooks: {
        after: t
      }
    }),
    isExpanded: u(n),
    viewportHeight: u(o),
    viewportStableHeight: u(s),
    isFullscreen: u(r),
    isOrientationLocked: u(i),
    isVerticalSwipesEnabled: u(c),
    safeAreaInset: u(f),
    contentSafeAreaInset: u(B),
    onChange: U
  };
}
function it() {
  const {
    webApp: e,
    isVerticalSwipesEnabled: t,
    updateState: n
  } = L(), o = d(e.enableVerticalSwipes, {
    hooks: {
      after: n
    }
  }), s = d(e.disableVerticalSwipes, {
    hooks: {
      after: n
    }
  });
  return {
    isVerticalSwipesEnabled: v({
      get() {
        return t.value;
      },
      set(r) {
        r ? o() : s();
      }
    })
  };
}
function at() {
  const {
    webApp: e,
    isFullscreen: t,
    isOrientationLocked: n,
    updateState: o
  } = L(), s = d(e.requestFullscreen, {
    hooks: {
      after: o
    }
  }), r = d(e.exitFullscreen, {
    hooks: {
      after: o
    }
  }), i = d(e.lockOrientation, {
    hooks: {
      after: o
    }
  }), c = d(e.unlockOrientation, {
    hooks: {
      after: o
    }
  });
  return {
    isFullscreen: v({
      get() {
        return t.value;
      },
      set(f) {
        f ? s() : r();
      }
    }),
    isOrientationLocked: v({
      get() {
        return n.value;
      },
      set(f) {
        f ? i() : c();
      }
    }),
    onSafeAreaChange: pe,
    onContentSafeAreaChange: fe,
    onFullscreenChange: Me,
    onFullscreenFail: Ve
  };
}
function ct(e) {
  const { webApp: t } = L(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...rt(),
    ...A(n, "7.7") && it(),
    ...A(n, "8.0") && at()
  };
}
const I = w(() => {
  const e = g(), t = a(e.MainButton.text), n = a(e.MainButton.color), o = a(e.MainButton.textColor), s = a(e.MainButton.isVisible), r = a(e.MainButton.isActive), i = a(e.MainButton.isProgressVisible), c = a(e.MainButton.hasShineEffect);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.MainButton.text, n.value = e.MainButton.color, o.value = e.MainButton.textColor, s.value = e.MainButton.isVisible, r.value = e.MainButton.isActive, i.value = e.MainButton.isProgressVisible, c.value = e.MainButton.hasShineEffect;
    },
    text: t,
    color: n,
    textColor: o,
    isVisible: s,
    isActive: r,
    isProgressVisible: i,
    hasShineEffect: c
  };
});
function ut() {
  const {
    webApp: e,
    updateState: t,
    text: n,
    color: o,
    textColor: s,
    isVisible: r,
    isActive: i,
    isProgressVisible: c,
    hasShineEffect: f
  } = I(), B = d(e.MainButton.showProgress, {
    hooks: {
      after: t
    },
    omitReturn: !0
  }), h = d(e.MainButton.hideProgress, {
    hooks: {
      after: t
    },
    omitReturn: !0
  }), S = d(e.MainButton.setParams, {
    hooks: {
      after: t
    },
    omitReturn: !0
  });
  return {
    text: v({
      get() {
        return n.value;
      },
      set(m) {
        S({ text: m });
      }
    }),
    color: v({
      get() {
        return o.value;
      },
      set(m) {
        S({ color: m });
      }
    }),
    textColor: v({
      get() {
        return s.value;
      },
      set(m) {
        S({ text_color: m });
      }
    }),
    isVisible: v({
      get() {
        return r.value;
      },
      set(m) {
        S({ is_visible: m });
      }
    }),
    isActive: v({
      get() {
        return i.value;
      },
      set(m) {
        S({ is_active: m });
      }
    }),
    isProgressVisible: v({
      get() {
        return c.value;
      },
      set(m) {
        m ? B() : h();
      }
    }),
    hasShineEffect: u(f),
    show: d(e.MainButton.show, {
      hooks: {
        after: t
      },
      omitReturn: !0
    }),
    hide: d(e.MainButton.hide, {
      hooks: {
        after: t
      },
      omitReturn: !0
    }),
    enable: d(e.MainButton.enable, {
      hooks: {
        after: t
      },
      omitReturn: !0
    }),
    disable: d(e.MainButton.disable, {
      hooks: {
        after: t
      },
      omitReturn: !0
    }),
    showProgress: B,
    hideProgress: h,
    setParams: S,
    onClick: Ae
  };
}
function lt() {
  const {
    webApp: e,
    updateState: t,
    hasShineEffect: n
  } = I(), o = d(e.MainButton.setParams, {
    hooks: {
      after: t
    },
    omitReturn: !0
  });
  return {
    hasShineEffect: v({
      get() {
        return n.value;
      },
      set(s) {
        o({ has_shine_effect: s });
      }
    })
  };
}
function dt(e) {
  const { webApp: t } = I(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...ut(),
    ...A(n, "7.10") && lt()
  };
}
const oe = w(() => ({
  webApp: g()
}));
function pt() {
  const {
    webApp: e
  } = oe();
  return {
    show: e.showScanQrPopup,
    close: e.closeScanQrPopup,
    onScan: be
  };
}
function ft() {
  return {
    onClose: we
  };
}
function At(e) {
  const { webApp: t } = oe(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "6.4") && pt(),
    ...A(n, "7.7") && ft()
  };
}
const F = w(() => {
  const e = g(), t = a(e.SecondaryButton.text), n = a(e.SecondaryButton.color), o = a(e.SecondaryButton.textColor), s = a(e.SecondaryButton.isVisible), r = a(e.SecondaryButton.isActive), i = a(e.SecondaryButton.isProgressVisible), c = a(e.SecondaryButton.hasShineEffect), f = a(e.SecondaryButton.position);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.SecondaryButton.text, n.value = e.SecondaryButton.color, o.value = e.SecondaryButton.textColor, s.value = e.SecondaryButton.isVisible, r.value = e.SecondaryButton.isActive, i.value = e.SecondaryButton.isProgressVisible, c.value = e.SecondaryButton.hasShineEffect, f.value = e.SecondaryButton.position;
    },
    text: t,
    color: n,
    textColor: o,
    isVisible: s,
    isActive: r,
    isProgressVisible: i,
    hasShineEffect: c,
    position: f
  };
});
function vt() {
  const {
    text: e,
    color: t,
    textColor: n,
    isVisible: o,
    isActive: s,
    isProgressVisible: r,
    hasShineEffect: i,
    position: c
  } = F();
  return {
    text: u(e),
    color: u(t),
    textColor: u(n),
    isVisible: u(o),
    isActive: u(s),
    isProgressVisible: u(r),
    hasShineEffect: u(i),
    position: u(c)
  };
}
function St() {
  const {
    webApp: e,
    text: t,
    color: n,
    textColor: o,
    isVisible: s,
    isActive: r,
    isProgressVisible: i,
    hasShineEffect: c,
    position: f,
    updateState: B
  } = F(), h = d(e.SecondaryButton.showProgress, {
    hooks: {
      after: B
    },
    omitReturn: !0
  }), S = d(e.SecondaryButton.hideProgress, {
    hooks: {
      after: B
    },
    omitReturn: !0
  }), m = d(e.SecondaryButton.setParams, {
    hooks: {
      after: B
    },
    omitReturn: !0
  });
  return {
    text: v({
      get() {
        return t.value;
      },
      set(p) {
        m({ text: p });
      }
    }),
    color: v({
      get() {
        return n.value;
      },
      set(p) {
        m({ color: p });
      }
    }),
    textColor: v({
      get() {
        return o.value;
      },
      set(p) {
        m({ text_color: p });
      }
    }),
    isVisible: v({
      get() {
        return s.value;
      },
      set(p) {
        m({ is_visible: p });
      }
    }),
    isActive: v({
      get() {
        return r.value;
      },
      set(p) {
        m({ is_active: p });
      }
    }),
    isProgressVisible: v({
      get() {
        return i.value;
      },
      set(p) {
        p ? h() : S();
      }
    }),
    hasShineEffect: v({
      get() {
        return c.value;
      },
      set(p) {
        m({ has_shine_effect: p });
      }
    }),
    position: v({
      get() {
        return f.value;
      },
      set(p) {
        m({ position: p });
      }
    }),
    show: d(e.SecondaryButton.show, {
      hooks: {
        after: B
      },
      omitReturn: !0
    }),
    hide: d(e.SecondaryButton.hide, {
      hooks: {
        after: B
      },
      omitReturn: !0
    }),
    enable: d(e.SecondaryButton.enable, {
      hooks: {
        after: B
      },
      omitReturn: !0
    }),
    disable: d(e.SecondaryButton.disable, {
      hooks: {
        after: B
      },
      omitReturn: !0
    }),
    showProgress: h,
    hideProgress: S,
    setParams: m,
    onClick: ve
  };
}
function mt(e) {
  const { webApp: t } = F(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...vt(),
    ...A(n, "7.10") && St()
  };
}
const q = w(() => {
  const e = g(), t = a(e.SettingsButton.isVisible);
  return {
    webApp: e,
    isVisible: t,
    updateState: () => {
      t.value = e.SettingsButton.isVisible;
    }
  };
});
function gt() {
  const {
    isVisible: e
  } = q();
  return {
    isVisible: u(e)
  };
}
function ht() {
  const {
    webApp: e,
    isVisible: t,
    updateState: n
  } = q(), o = d(e.SettingsButton.show, {
    hooks: {
      after: n
    },
    omitReturn: !0
  }), s = d(e.SettingsButton.hide, {
    hooks: {
      after: n
    },
    omitReturn: !0
  });
  return {
    isVisible: v({
      get() {
        return t.value;
      },
      set(r) {
        r ? o() : s();
      }
    }),
    show: o,
    hide: s,
    onClick: me
  };
}
function bt(e) {
  const { webApp: t } = q(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...gt(),
    ...A(n, "7.0") && ht()
  };
}
const P = w(() => {
  const e = g(), t = a(e.Accelerometer.isStarted), n = a(e.Accelerometer.x), o = a(e.Accelerometer.y), s = a(e.Accelerometer.z);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.Accelerometer.isStarted, n.value = e.Accelerometer.x, o.value = e.Accelerometer.y, s.value = e.Accelerometer.z;
    },
    isStarted: t,
    x: n,
    y: o,
    z: s
  };
});
function wt() {
  const {
    isStarted: e,
    x: t,
    y: n,
    z: o
  } = P();
  return {
    isStarted: u(e),
    x: u(t),
    y: u(n),
    z: u(o)
  };
}
function Ct() {
  const {
    webApp: e,
    updateState: t
  } = P(), n = b(e.Accelerometer.start);
  function o(i, c) {
    if (c)
      e.Accelerometer.start(i, c);
    else
      return n(i);
  }
  const s = b(e.Accelerometer.stop);
  function r(i) {
    if (i)
      e.Accelerometer.stop(i);
    else
      return s();
  }
  return _(t), K(t), {
    start: o,
    stop: r,
    onStart: Re,
    onStop: xe,
    onChange: _,
    onFail: K
  };
}
function Bt(e) {
  const { webApp: t } = P(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...wt(),
    ...A(n, "8.0") && Ct()
  };
}
const se = w(() => ({
  webApp: g()
}));
function yt() {
  const {
    webApp: e
  } = se(), t = b(e.readTextFromClipboard);
  function n(o) {
    if (o)
      e.readTextFromClipboard(o);
    else
      return t();
  }
  return {
    readText: n,
    onReadText: Ce
  };
}
function Mt(e) {
  const { webApp: t } = se(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "6.4") && yt()
  };
}
const re = w(() => ({
  webApp: g()
}));
function Vt() {
  const {
    webApp: e
  } = re(), t = V(e.CloudStorage.setItem);
  function n(p, y, G) {
    if (G)
      e.CloudStorage.setItem(p, y, G);
    else
      return t(p, y);
  }
  const o = V(e.CloudStorage.getItem);
  function s(p, y) {
    if (y)
      e.CloudStorage.getItem(p, y);
    else
      return o(p);
  }
  const r = V(e.CloudStorage.getItems);
  function i(p, y) {
    if (y)
      e.CloudStorage.getItems(p, y);
    else
      return r(p);
  }
  const c = V(e.CloudStorage.removeItem);
  function f(p, y) {
    if (y)
      e.CloudStorage.removeItem(p, y);
    else
      return c(p);
  }
  const B = V(e.CloudStorage.removeItems);
  function h(p, y) {
    if (y)
      e.CloudStorage.removeItems(p, y);
    else
      return B(p);
  }
  const S = V(e.CloudStorage.getKeys);
  function m(p) {
    if (p)
      e.CloudStorage.getKeys(p);
    else
      return S();
  }
  return {
    setItem: n,
    getItem: s,
    getItems: i,
    removeItem: f,
    removeItems: h,
    getKeys: m
  };
}
function Lt(e) {
  const { webApp: t } = re(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "6.9") && Vt()
  };
}
const O = w(() => {
  const e = g(), t = a(e.DeviceOrientation.isStarted), n = a(e.DeviceOrientation.absolute), o = a(e.DeviceOrientation.alpha), s = a(e.DeviceOrientation.beta), r = a(e.DeviceOrientation.gamma);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.DeviceOrientation.isStarted, n.value = e.DeviceOrientation.absolute, o.value = e.DeviceOrientation.alpha, s.value = e.DeviceOrientation.beta, r.value = e.DeviceOrientation.gamma;
    },
    isStarted: t,
    absolute: n,
    alpha: o,
    beta: s,
    gamma: r
  };
});
function kt() {
  const {
    isStarted: e,
    absolute: t,
    alpha: n,
    beta: o,
    gamma: s
  } = O();
  return {
    isStarted: u(e),
    absolute: u(t),
    alpha: u(n),
    beta: u(o),
    gamma: u(s)
  };
}
function Rt() {
  const {
    webApp: e,
    updateState: t
  } = O(), n = b(e.DeviceOrientation.start);
  function o(i, c) {
    if (c)
      e.DeviceOrientation.start(i, c);
    else
      return n(i);
  }
  const s = b(e.DeviceOrientation.stop);
  function r(i) {
    if (i)
      e.DeviceOrientation.stop(i);
    else
      return s();
  }
  return N(t), J(t), {
    start: o,
    stop: r,
    onStart: Ee,
    onStop: Ie,
    onChange: N,
    onFail: J
  };
}
function xt(e) {
  const { webApp: t } = O(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...kt(),
    ...A(n, "8.0") && Rt()
  };
}
const ie = w(() => ({
  webApp: g()
}));
function Et() {
  const {
    webApp: e
  } = ie(), t = b(e.setEmojiStatus);
  function n(r, i, c) {
    if (c)
      e.setEmojiStatus(r, i, c);
    else
      return t(r, i);
  }
  const o = b(e.requestEmojiStatusAccess);
  function s(r) {
    if (r)
      e.requestEmojiStatusAccess(r);
    else
      return o();
  }
  return {
    set: n,
    requestAccess: s,
    onSet: Te,
    onFail: De,
    onAccessRequest: Ge
  };
}
function It(e) {
  const { webApp: t } = ie(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "8.0") && Et()
  };
}
const T = w(() => {
  const e = g(), t = a(e.Gyroscope.isStarted), n = a(e.Gyroscope.x), o = a(e.Gyroscope.y), s = a(e.Gyroscope.z);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.Gyroscope.isStarted, n.value = e.Gyroscope.x, o.value = e.Gyroscope.y, s.value = e.Gyroscope.z;
    },
    isStarted: t,
    x: n,
    y: o,
    z: s
  };
});
function Ft() {
  const {
    isStarted: e,
    x: t,
    y: n,
    z: o
  } = T();
  return {
    isStarted: u(e),
    x: u(t),
    y: u(n),
    z: u(o)
  };
}
function qt() {
  const {
    webApp: e,
    updateState: t
  } = T(), n = b(e.Gyroscope.start);
  function o(i, c) {
    if (c)
      e.Gyroscope.start(i, c);
    else
      return n(i);
  }
  const s = b(e.Gyroscope.stop);
  function r(i) {
    if (i)
      e.Gyroscope.stop(i);
    else
      return s();
  }
  return X(t), Y(t), {
    start: o,
    stop: r,
    onStart: Fe,
    onStop: qe,
    onChange: X,
    onFail: Y
  };
}
function Pt(e) {
  const { webApp: t } = T(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...Ft(),
    ...A(n, "8.0") && qt()
  };
}
const ae = w(() => ({
  webApp: g()
}));
function Ot() {
  const {
    webApp: e
  } = ae(), t = d(e.HapticFeedback.impactOccurred, {
    omitReturn: !0
  }), n = d(e.HapticFeedback.notificationOccurred, {
    omitReturn: !0
  }), o = d(e.HapticFeedback.selectionChanged, {
    omitReturn: !0
  });
  return {
    impactOccurred: t,
    notificationOccurred: n,
    selectionChanged: o
  };
}
function Tt(e) {
  const { webApp: t } = ae(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "6.1") && Ot()
  };
}
const ce = w(() => ({
  webApp: g()
}));
function Dt() {
  const {
    webApp: e
  } = ce(), t = b(e.checkHomeScreenStatus);
  function n(o) {
    if (o)
      e.checkHomeScreenStatus(o);
    else
      return t();
  }
  return {
    addShortcut: e.addToHomeScreen,
    checkShortcutStatus: n,
    onShortcutAdd: Le,
    onShortcutCheck: ke
  };
}
function Gt(e) {
  const { webApp: t } = ce(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...A(n, "8.0") && Dt()
  };
}
const D = w(() => {
  const e = g(), t = a(e.LocationManager.isInited), n = a(e.LocationManager.isLocationAvailable), o = a(e.LocationManager.isAccessRequested), s = a(e.LocationManager.isAccessGranted);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.LocationManager.isInited, n.value = e.LocationManager.isLocationAvailable, o.value = e.LocationManager.isAccessRequested, s.value = e.LocationManager.isAccessGranted;
    },
    isInited: t,
    isLocationAvailable: n,
    isAccessRequested: o,
    isAccessGranted: s
  };
});
function Ht() {
  const {
    isInited: e,
    isLocationAvailable: t,
    isAccessRequested: n,
    isAccessGranted: o
  } = D();
  return {
    isInited: u(e),
    isLocationAvailable: u(t),
    isAccessRequested: u(n),
    isAccessGranted: u(o)
  };
}
function jt() {
  const {
    webApp: e,
    updateState: t
  } = D(), n = R(e.LocationManager.init);
  function o(i) {
    if (i)
      e.LocationManager.init(i);
    else
      return n();
  }
  const s = b(e.LocationManager.getLocation);
  function r(i) {
    if (i)
      e.LocationManager.getLocation(i);
    else
      return s();
  }
  return Z(t), ee(t), {
    init: o,
    getLocation: r,
    openSettings: d(e.LocationManager.openSettings, {
      omitReturn: !0
    }),
    onManagerUpdate: Z,
    onRequest: ee
  };
}
function $t(e) {
  const { webApp: t } = D(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...Ht(),
    ...A(n, "8.0") && jt()
  };
}
const k = w(() => {
  const e = g(), t = a(e.colorScheme), n = a(e.themeParams), o = a(e.headerColor), s = a(e.backgroundColor), r = a(e.bottomBarColor);
  return {
    webApp: e,
    updateState: () => {
      t.value = e.colorScheme, n.value = {
        ...e.themeParams
      }, o.value = e.headerColor, s.value = e.backgroundColor, r.value = e.bottomBarColor;
    },
    colorScheme: t,
    themeParams: n,
    headerColor: o,
    backgroundColor: s,
    bottomBarColor: r
  };
});
function Ut() {
  const {
    colorScheme: e,
    themeParams: t,
    headerColor: n,
    backgroundColor: o,
    bottomBarColor: s,
    updateState: r
  } = k();
  return $(r), {
    colorScheme: u(e),
    themeParams: u(t),
    headerColor: u(n),
    backgroundColor: u(o),
    bottomBarColor: u(s),
    onChange: $
  };
}
function Wt() {
  const {
    webApp: e,
    headerColor: t,
    backgroundColor: n,
    updateState: o
  } = k(), s = d(e.setHeaderColor, {
    hooks: {
      after: o
    }
  }), r = d(e.setBackgroundColor, {
    hooks: {
      after: o
    }
  });
  return {
    headerColor: v({
      get() {
        return t.value;
      },
      set(i) {
        s(i);
      }
    }),
    backgroundColor: v({
      get() {
        return n.value;
      },
      set(i) {
        r(i);
      }
    })
  };
}
function zt() {
  const {
    webApp: e,
    bottomBarColor: t,
    updateState: n
  } = k(), o = d(e.setBottomBarColor, {
    hooks: {
      after: n
    }
  });
  return {
    bottomBarColor: v({
      get() {
        return t.value;
      },
      set(s) {
        o(s);
      }
    })
  };
}
function Qt(e) {
  const { webApp: t } = k(), n = C(e == null ? void 0 : e.version, t.version);
  return {
    version: t.version,
    isVersionAtLeast: t.isVersionAtLeast,
    ...Ut(),
    ...A(n, "6.1") && Wt(),
    ...A(n, "7.10") && zt()
  };
}
function Nt(e) {
  return {
    useAccelerometer: () => Bt({ version: e }),
    useBackButton: () => Qe({ version: e }),
    useBiometricManager: () => Ne({ version: e }),
    useClipboard: () => Mt({ version: e }),
    useCloudStorage: () => Lt({ version: e }),
    useDeviceOrientation: () => xt({ version: e }),
    useEmojiStatus: () => It({ version: e }),
    useGyroscope: () => Pt({ version: e }),
    useHapticFeedback: () => Tt({ version: e }),
    useHomeScreen: () => Gt({ version: e }),
    useLocationManager: () => $t({ version: e }),
    useMainButton: () => dt({ version: e }),
    useMiniApp: () => ot({ version: e }),
    usePopup: () => Ue({ version: e }),
    useQrScanner: () => At({ version: e }),
    useSecondaryButton: () => mt({ version: e }),
    useSettingsButton: () => bt({ version: e }),
    useTheme: () => Qt({ version: e }),
    useViewport: () => ct({ version: e })
  };
}
export {
  Z as $,
  ye as A,
  Be as B,
  me as C,
  Qt as D,
  $ as E,
  Kt as F,
  H as G,
  j as H,
  pe as I,
  fe as J,
  ve as K,
  Me as L,
  Ve as M,
  Le as N,
  ke as O,
  Re as P,
  xe as Q,
  _ as R,
  K as S,
  Ee as T,
  Ie as U,
  N as V,
  J as W,
  Fe as X,
  qe as Y,
  X as Z,
  Y as _,
  Qe as a,
  ee as a0,
  Pe as a1,
  Oe as a2,
  Te as a3,
  De as a4,
  Ge as a5,
  He as a6,
  Ne as b,
  Nt as c,
  ot as d,
  ct as e,
  dt as f,
  At as g,
  mt as h,
  bt as i,
  g as j,
  l as k,
  Se as l,
  W as m,
  z as n,
  U as o,
  Q as p,
  Mt as q,
  Ce as r,
  Lt as s,
  Tt as t,
  Ue as u,
  Ae as v,
  ge as w,
  he as x,
  be as y,
  we as z
};
